import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class OrderDownloadResource extends AuthenticatedResource {
  static urlRoot = '/admin/orders/download' as const;

  pk() {
    return 'download';
  }
}
